    import LeaveTable from "./LeaveTable";

    const HrLeaveManagement = () => <LeaveTable role="HR" />;
    export default HrLeaveManagement;